import request from "@/util/request";

//环境监测（和气象站一样）

/*------------------------------------------------------------*/

//根据气象站id获取实时数据
export function getWeatherNowByWlwWeatherId(data) {
  return request({
    url: "api/restful/getScreenV2FindWlwWeatherNowByWlwWeatherId",
    method: "get",
    params: data
  });
}

//根据气象站id获取今天数据
export function getWlwWeatherByToDay(data) {
  return request({
    url: "api/restful/getScreenV2FindWlwWeatherGetToDay",
    method: "get",
    params: data
  });
}

// 根据气象站id获取一段时间内的日均数据
export function getScreenV2FindWlwWeatherGetRJSJ(data) {
  return request({
    url: "api/restful/getScreenV2FindWlwWeatherGetRJSJ",
    method: "get",
    params: data
  });
}

// 根据气象站id获取一段时间内的历史数据
export function findWlwWeatherGetLSSJ(data) {
  return request({
    url: "api/restful/getScreenV2FindWlwWeatherGetLSSJ",
    method: "get",
    params: data
  });
}

// 根据墒情id获取今天数据
export function getWlwSoilGetToDay(data) {
  return request({
    url: "/api/restful/getScreenV2FindWlwSoilGetCodeToDay",
    method: "get",
    params: data
  });
}
// 根据墒情id获取一段时间内的日均数据
export function getWlwSoilGetRJSJ(data) {
  return request({
    url: "api/restful/getScreenV2FindWlwSoilGetRJSJ",
    method: "get",
    params: data
  });
}

// 获取气象设备数据
export function getSmartwlMapData(data) {
  return request({
    url: "api/restful/getSmartwlMapData",
    method: "get",
    params: data
  });
}

// 根据设备code获取预警信息
export function findWlwWarningByWlwCode(data) {
  return request({
    url: "api/restful/getScreenV2FindWlwWarningByWlwCode",
    method: "get",
    params: data
  });
}
//获取园区气象站数据
export function getWlwWeatherData(data) {
  return request({
    url: "/api/restful/getWlwWeatherData",
    method: "get",
    params: data
  });
}
// 获取园区气象站设备
export function getHasHistoryDevice(data) {
  return request({
    url: "/api/restful/getHasHistoryDevice",
    method: "get",
    params: data
  });
}
// 获取园区气象站实时数据
export function findDataZhwlLdsmmQxzData(data) {
  return request({
    url: "/api/restful/findDataZhwlQxzData",
    method: "get",
    params: data
  });
}
//根据实时数据获取当前历史数据
export function getSmartwlMapLdsmmQxzData(data) {
  return request({
    url: "/api/restful/getSmartwlMapQxzData",
    method: "get",
    params: data
  });
}
//摄像头控制开始
export function controlCamera(data) {
  return request({
    url: "/api/restful/wlwVideo/controlCamera",
    method: "get",
    params: data
  });
}
//摄像头控制结束
export function stopCamera(data) {
  return request({
    url: "/api/restful/wlwVideo/stopCamera",
    method: "get",
    params: data
  });
}
//摄像头拍照功能
export function photographUrlPZ(data) {
  return request({
    url: "/api/restful/photographUrlPZ",
    method: "get",
    params: data
  });
}

export function getScreenV2WlwNqImageByWlwCodeSameMonth(data) {
  return request({
    url: "/api/restful/getScreenV2WlwNqImageByWlwCodeSameMonth",
    method: "get",
    params: data
  });
}

// 根据视频设备号获取一个月前的照片
export function getScreenV2WlwVideoImageByWlwCodeSameMonth(data) {
  return request({
    url: "/api/restful/getScreenV2WlwVideoImageByWlwCodeSameMonth",
    method: "get",
    params: data
  });
}
//查看历史数据
export function getCallRemoteHistoryData(data) {
  return request({
    url: "/api/restful/getCallRemoteHistoryData",
    method: "get",
    params: data
  });
}
//查询设备最新数据
export function findQxzWlwnNwestData(data) {
  return request({
    url: "/api/restful/findQxzWlwnNwestData",
    method: "get",
    params: data
  });
}

// 土壤墒情
export function getScreenV2FindWlwSoilGetLSSJ(data) {
  return request({
    url: "/api/restful/getScreenV2FindWlwSoilGetLSSJ",
    method: "get",
    params: data
  });
}

// 墒情监测
export function getScreenV2FindWlwSoilNowByWlwSoilId(data) {
  return request({
    url: "/api/restful/getScreenV2FindWlwSoilNowByWlwSoilId",
    method: "get",
    params: data
  });
}

// 农情监测
export function getWlwInfoImageSbGroupByDayAndWlwCode(data) {
  return request({
    url: "/api/restful/getWlwInfoImageSbGroupByDayAndWlwCode",
    method: "get",
    params: data
  });
}

//  病虫害上面的图集
export function getWlwPestImageTj(data) {
  return request({
    url: "/api/restful/getWlwPestImageTj",
    method: "get",
    params: data
  });
}

//  近5月 虫量占比
export function getWlwPestDataLimitFive(data) {
  return request({
    url: "/api/restful/getWlwPestDataLimitFive",
    method: "get",
    params: data
  });
}

//  近15日 虫量走势
export function getWlwPestDataTypeSum(data) {
  return request({
    url: "/api/restful/getWlwPestDataTypeSum",
    method: "get",
    params: data
  });
}

export function getWlwCode(data) {
  return request({
    url: "/api/restful/nyy/getWlwCode",
    method: "get",
    params: data
  });
}

// 获取农语云设备实时数据
export function findRealData(device_id) {
  return request({
    url: "/api/restful/nyy/getDetailById?device_id=" + device_id,
    method: "get"
  });
}
// 获取农语云设备历史数据
export function findHistoryData(data) {
  return request({
    url: "/api/restful/nyy/selectSensorData2",
    method: "get",
    params: data
  });
}
